'use client'

import React from 'react'
import { CampaignBanner, type CampaignSurface } from './campaign-banner'
import { usePublicCampaign } from './use-public-campaign'

/**
 * Home / pricing mount point for the featured campaign.
 *
 * Renders NOTHING while loading or when no campaign is listed — an empty shell
 * or a skeleton would punch a hole in the marketing page for the ordinary case
 * of "no campaign running", which is most of the time.
 *
 * `/c/[slug]` deliberately does NOT use a client lookup like this one: it
 * resolves the campaign on the server so an unreachable slug is a real 404
 * rather than a page that empties itself after hydration.
 */
export function FeaturedCampaignSection({
  surface,
  sectionId,
  className,
  hideForPaidSubscribers,
}: {
  /** Which page mounted this — reported on every campaign event. */
  surface: CampaignSurface
  sectionId?: string
  className?: string
  hideForPaidSubscribers?: boolean
}) {
  const { campaign, reload } = usePublicCampaign()
  if (!campaign) return null
  return (
    <CampaignBanner
      campaign={campaign}
      surface={surface}
      sectionId={sectionId}
      className={className}
      hideForPaidSubscribers={hideForPaidSubscribers}
      onClaimed={reload}
    />
  )
}
